"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var createMiddlewareData = function createMiddlewareData(dispatchValue, payload, storeItem, state, store, modules) {
  var _state$trebleCoreData;

  var handleInitialState = function handleInitialState() {
    var _store$find;

    var stateObject = (_store$find = store.find(function (item) {
      return item.action === storeItem.action;
    })) === null || _store$find === void 0 ? void 0 : _store$find.state;

    if (stateObject !== undefined) {
      var stateKey = Object.keys(stateObject)[0];
      return stateObject[stateKey];
    }
  };

  return {
    dispatchValue: dispatchValue,
    dispatchPayload: payload,
    initialDispatchValue: dispatchValue,
    action: storeItem.action,
    features: storeItem.features,
    currentState: state[Object.keys(storeItem.state)[0]],
    initialState: handleInitialState(),
    storeItems: store,
    storeState: state,
    storeModules: modules,
    dispatchers: state === null || state === void 0 ? void 0 : (_state$trebleCoreData = state.trebleCoreData) === null || _state$trebleCoreData === void 0 ? void 0 : _state$trebleCoreData.subscribeAPI
  };
};

var _default = createMiddlewareData;
exports["default"] = _default;
module.exports = exports.default;